<h2 class="pb-[2.5rem]">{{ 'documents.title' | transloco }}</h2>
@if(loading()){
<div class="my-[6.25rem]"><loader /></div>
} @else {
<div class="flex flex-col gap-[1.5rem]">
  <div
    class="flex flex-col gap-[2rem] md:p-[2.5rem] p-[1.5rem] bg-white rounded-xl"
  >
    <div class="flex items-center gap-4 pb-[0.875rem]">
      <icon [name]="'folder'" [size]="'1.5625rem'"></icon>
      <h4>{{ 'documents.addedDocumentsSection' | transloco }}</h4>
    </div>
    <p>{{ 'documents.addedDocumentsText' | transloco }}</p>
    @if(documents().length !== 0) {
    <div class="flex flex-col gap-[1rem]">
      @for(document of documents(); track $index) {
      <div
        class="p-4 flex flex-col md:flex-row md:justify-between gap-2 rounded-lg border border-vinciBlue-300"
      >
        <div
          class="flex flex-col md:flex-row md:items-center gap-1 md:gap-[0.875rem] min-w-0"
        >
          <p class="flex gap-3 min-w-0">
            <icon [name]="'document'" [size]="'1.4375rem'" class="mt-0.5 shrink-0"></icon>
            <span class="break-all">{{ document.name }}</span>
          </p>
          <span class="text-vinciGrey-400 text-sm"
            >{{ 'documents.addedAt' | transloco }} {{ document.createdAt |
            date:'shortDate':undefined:currentLocale }}</span
          >
        </div>
        <div class="flex flex-col md:flex-row gap-3">
          <app-button
            [text]="'documents.ctaDeleteText' | transloco"
            [variant]="'destructive'"
            [icon]="'trash'"
            [iconSize]="'1.125rem'"
            [iconPosition]="'left'"
            (buttonClick)="openModal(document)"
            class="max-md:w-full"
          />
          <app-button
            [text]="'documents.ctaDownloadText' | transloco"
            [variant]="'quaternary'"
            [icon]="'arrow-down'"
            [iconSize]="'1.125rem'"
            [iconPosition]="'left'"
            (buttonClick)="downloadDocument(document.documentId)"
            class="max-md:w-full"
          />
        </div>
      </div>
      }
    </div>
    }
  </div>
  <div class="flex flex-col p-[1.5rem] md:p-[2.5rem] bg-white rounded-xl mb-[2.5rem]">
    <div class="flex items-center gap-4 pb-[0.875rem]">
      <icon [name]="'plus'" [size]="'1.5625rem'"></icon>
      <h4>{{ 'documents.addDocuments' | transloco }}</h4>
    </div>
    <div class="flex flex-col gap-3 mb-6">
      <p>
        <span class="mobile-hidden"
          >{{ 'documents.addDocumentsText' | transloco }}</span
        >
        {{ 'documents.verifyDocType' | transloco }}
      </p>
      @if(fileTooHeavy()) {
      <div class="flex gap-2 items-center text-vinciRed-600">
        <icon [name]="'infobulle'" [size]="'1.25rem'" />
        <p class="!text-sm !font-bold">
          {{ 'documents.fileSizeError' | transloco:{ maxSize: '10 Mo' } }}
        </p>
      </div>
      }
    </div>

    <app-file-drop-zone
      [multiple]="true"
      (newFile)="addDocument($event)"
      (fileError)="setFileTooHeavy($event)"
      (openErrorModal)="openErrorModal()"
      class="mobile-hidden"
    ></app-file-drop-zone>
    <input
      #fileInput
      type="file"
      accept=".pdf"
      multiple
      hidden
      (change)="onFileSelected($event)"
    />
    <app-button
      [text]="'documents.addDocuments' | transloco"
      [icon]="'plus'"
      [variant]="'secondary'"
      (buttonClick)="triggerFileInput()"
      class="desktop-hidden"
    ></app-button>
  </div>
</div>
} @if (isModalOpen()) {
<app-modal
  [title]="'documents.modalTitle' | transloco"
  [text]="'documents.modalText' | transloco"
  [buttonText]="'documents.modalCtaText' | transloco"
  [type]="'secondary'"
  (completeModal)="completeModal()"
  (closeModal)="closeModal()"
></app-modal>
} @if (isErrorModalOpen()) {
<app-modal
  [title]="'documents.modalErrorTitle' | transloco"
  [text]="'documents.modalErrorText' | transloco"
  [buttonText]="'documents.modalErrorCtaText' | transloco"
  [type]="'primary'"
  (completeModal)="closeErrorModal()"
  (closeModal)="closeErrorModal()"
></app-modal>
}
